<label class="switch" [attr.data-testid]="testId + '-label'">
  <input type="checkbox" [attr.data-testid]="testId" [(ngModel)]="model" (change)="emitSwitchValue($event)" [disabled]="disabled">
  <span class="track"></span>
</label>
